import { showBackdrop, hideBackdrop } from '../components/backdrop';
import { atQuery } from '../components/mediaQueries';

$(function () {
  const $countrySwitcher = $('.country-switcher');
  const $countrySwitcherModal = $('.country-switcher__modal');

  if (!$countrySwitcher.length || !$countrySwitcherModal.length) return;

  const $countrySwitcherModalSearch = $('.country-switcher__modal__search');
  const $countrySwitcherModalClose = $('.country-switcher__modal__close');

  $countrySwitcher.on('click', function () {
    $countrySwitcherModal.addClass('open');
    $('body').addClass('country-lang-open');

    atQuery('min', 'md', () => {
      showBackdrop();
    });
  });

  const $activeCountry = $countrySwitcher.find('.country-switcher__active-country');
  if ($activeCountry.length <= 0) return;

  $activeCountry.on('blur', function (e) {
    if (!e.relatedTarget || !e.relatedTarget.closest('.country-switcher__dropdown')) {
      $countrySwitcher.removeClass('open');
    }
  });

  $($countrySwitcherModalClose).on('click', function(e) {
    e.stopPropagation();
    $countrySwitcherModal.removeClass('open');
    $('body').removeClass('country-lang-open');

    atQuery('min', 'md', () => {
      hideBackdrop();
    });
  });

  $countrySwitcherModalSearch.on('input', (e) => {
    var input, filter, $ul, $li, a, i, txtValue;
    input = e.target;
    filter = input.value.toUpperCase();
    $ul = $countrySwitcherModal.find("#CountryList");
    $li = $ul.find('.country-switcher__modal__disclosure__item');

    for (i = 0; i < $li.length; i++) {
      a = $li[i].querySelector("a");
      txtValue = $(a).text();
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        $li[i].style.display = "flex";
      } else {
        $li[i].style.display = "none";
      }
    }
});
});
